import { Component } from 'react';

export default class NoMatch extends Component {
    render() {
        return '404 Not found';
    }
}
